import { HttpClient } from '@angular/common/http';
import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';
import { LoadingService } from '../../shared/services/loading.service';
import { ReturnCheck } from '../return-checks/models/return-check';
import { ReturnCheckImage } from '../return-checks/models/return-check-image';
import { SelectOption } from '../../shared/interfaces/select-option';

@Injectable({
  providedIn: 'root',
})
export class BankingService {
  #httpClient = inject(HttpClient);
  #loadingService = inject(LoadingService);
  #api: string = 'banking/';

  private destroyRef = inject(DestroyRef);
  private _allAgencies = signal<SelectOption[]>([]);
  private _allFunds = signal<SelectOption[]>([]);
  private _returnChecks = signal<ReturnCheck[]>([]);

  readonly returnChecks = this._returnChecks.asReadonly();
  readonly allAgencies = this._allAgencies.asReadonly();
  readonly allFunds = this._allFunds.asReadonly();

  setReturnChecksSignal(value: ReturnCheck[]) {
    this._returnChecks.set(value);
  }

  getAllAgencies() {
    this.#loadingService.showLoadingIndicator();
    this.#httpClient.get<SelectOption[]>(`${this.#api}agency/agencies-selectable`)
      .pipe(finalize(() => { this.#loadingService.hideLoadingIndicator(); }), takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (response) => {
          this._allAgencies.set(response);
        }
      });
  }

  getAllFunds() {
    this.#loadingService.showLoadingIndicator();
    this.#httpClient.get<SelectOption[]>(`${this.#api}fundAccounting/get-all-funds-selectable`)
      .pipe(finalize(() => { this.#loadingService.hideLoadingIndicator(); }), takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (response) => {
          this._allFunds.set(response);
        }
      });
  }

  getReturnChecks({ agencyId, beginDate, endDate }: ReturnCheckImage) {
    this.#loadingService.showLoadingIndicator();
    this.#httpClient.post<ReturnCheck[]>(`${this.#api}returnchecks/download-return-checks-images`, { agencyId, beginDate, endDate })
      .pipe(finalize(() => { this.#loadingService.hideLoadingIndicator(); }), takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (response) => {
          this.setReturnChecksSignal(response);
        }
      });
  }
}
